/* @flow */

import * as React from 'react';

import {Popover} from 'shells/popover';
import {PopoverForm} from 'shells/popover-form';
import {FormField, ConditionalCheckboxInput} from 'shells/form';

import {PipelineSelectPicker} from '../../../core/form/fields/pipeline-select-picker';

type Props = {
    anchor: React.Node,
    name: string,
    onClose: () => void,
    onCreate: (createLead: boolean, stagesetId: ?string) => Promise<*>,
};

export function AddCompanyPopover(props: Props) {
    const [isSaving, setIsSaving] = React.useState<boolean>(false);
    const [createNewLead, setCreateNewLead] = React.useState<boolean>(false);
    const [selectedStagesetId, setSelectedStagesetId] = React.useState<?string>(null);

    const onSubmit = () => {
        const stagesetId = selectedStagesetId ? selectedStagesetId : undefined;

        setIsSaving(true);
        props.onCreate(createNewLead, stagesetId);
    };

    return (
        <Popover anchor={props.anchor} onBlur={props.onClose} location='top'>
            <PopoverForm
                width={340}
                height={198}
                allowTitleWrapping={true}
                onClose={props.onClose}
                title={`Create ${props.name} as a company in Nutshell`}
                isSaving={isSaving}
                saveButtonSavingText='Adding'
                saveButtonSuccessText='Added!'
                onSubmit={onSubmit}
                saveButtonText={
                    createNewLead && selectedStagesetId ? 'Create company & lead' : 'Create company'
                }
            >
                <FormField innerId='createNewLead'>
                    <ConditionalCheckboxInput
                        checked={createNewLead}
                        label='Also create new lead'
                        onChange={(newValue) => {
                            setCreateNewLead(newValue);
                        }}
                    >
                        <PipelineSelectPicker
                            minHeight={39}
                            autoselectDefault={true}
                            selectedPipeline={selectedStagesetId}
                            onSelectPipeline={(id: string) => setSelectedStagesetId(id)}
                        />
                    </ConditionalCheckboxInput>
                </FormField>
            </PopoverForm>
        </Popover>
    );
}
